import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setPromotions = info => {
	return {
		type: ActionTypes.LOAD_PROMOTIONS,
		promotions: info.data
	};
};

export const loadPromotions = () => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/solanasapi/promociones")
			.then(response => {
				dispatch(setPromotions(response.data));
			})
			.catch(error => {});
	};
};

export const savePromotions = (promotion, token) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.update(
				"https://solanas-cors.herokuapp.com/http://190.105.227.203/solanasapi/promociones/",
				promotion,
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const createPromotion = (promotion, token, imageUrl) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"https://solanas-cors.herokuapp.com/http://190.105.227.203/solanasapi/promociones/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					orden: promotion.orden,
					image: imageUrl
				},
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const uploadImageAndCreatePromotion = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"https://solanas-cors.herokuapp.com/http://190.105.227.203/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(createPromotion(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const deletePromotion = (promotion, token) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
			.delete(
				"https://solanas-cors.herokuapp.com/http://190.105.227.203/solanasapi/promociones/" +
					promotion.id,
				{
					headers: { Authorization: AuthStr }
				},
				{ data: promotion }
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};
